// ============================================================================
// Funciones apagadas por plataforma (preset `disabledFeatures`).
// ============================================================================
// Decisión del dueño (2026-10-28, hasta nuevo aviso): en WAYAK no operan las
// Finanzas internas, la Nómina, la Gestión de Staff y Horas ni las facturas y
// cotizaciones del CRM; se centralizan en CC-CONSOLE. El código se queda
// (paridad entre forks) pero apagado: el preset las oculta del menú, sus rutas
// redirigen al inicio (router/platformFeatureRoutes.tsx) y el API responde 404
// FEATURE_DISABLED_ON_PLATFORM (functions/src/config/tenantFeatures.js).
//
// Ajuste (2026-10-29): Gestión de Staff › Actividades (`staff-actividades`) SÍ
// opera en WAYAK, pero sin costos de personas: salen de sueldos y tarifas, y
// los montos de nómina sólo viven en CC-CONSOLE (`canShowStaffCosts`).
// ============================================================================

import { appsConfig } from "./appsConfig";
import type { AppsPreset, PlatformFeature } from "./apps/types";

/** ¿Está encendida esta familia en el preset activo (o en el que se pase)? */
export function isPlatformFeatureEnabled(
  feature: PlatformFeature,
  preset: Pick<AppsPreset, "disabledFeatures"> = appsConfig,
): boolean {
  return !(preset.disabledFeatures ?? []).includes(feature);
}

/**
 * ¿Se muestran costos de personas (tarifa/sueldo × tiempo) en Actividades? Sólo
 * con Nómina y Staff encendidas. El API ya no los manda en WAYAK; esto evita
 * pintar una columna o tarjeta de costo vacía.
 */
export function canShowStaffCosts(preset: Pick<AppsPreset, "disabledFeatures"> = appsConfig): boolean {
  return isPlatformFeatureEnabled("nomina", preset) && isPlatformFeatureEnabled("staff", preset);
}
